import { render, staticRenderFns } from "./QuoteEmailed.vue?vue&type=template&id=10d88bb8&scoped=true&"
import script from "./QuoteEmailed.vue?vue&type=script&lang=js&"
export * from "./QuoteEmailed.vue?vue&type=script&lang=js&"
import style0 from "./QuoteEmailed.vue?vue&type=style&index=0&id=10d88bb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d88bb8",
  null
  
)

export default component.exports